<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 py-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pt-0"
                append-icon="mdi-account-search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Designation':'Search'"
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                class="pt-1"
                :headers="desigSm"
                :items="desigList"
                title="Employee Designation"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="py-3 px-0">
            <v-layout>
              <v-flex xs12>
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?desigSm:desig"
                :items="desigList"
                hide-default-footer
                :search="search"
                disable-pagination
                :mobile-breakpoint="0"
                sort-by="emp_desig"
                class="elevation-3">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareEditDesig(props.item)">
                    <td>{{ props.item.emp_desig }}</td>
                    <td>{{ props.item.tot_emp }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_male }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_female }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
      <v-layout row wrap>
        <v-flex xs12 mx-auto>
          <v-form ref="dForm" @submit.prevent="saveEmployeeDesign(lAction)">
            <v-card flat>
              <v-card-title class="title">
                {{ handy.startWithUpper(lAction) + ' Employee Designation' }}
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                    v-model="lEmpDesig.emp_desig"
                    label="Designation"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="35"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="lAction === 'update'" @click="deleteDesign(lEmpDesig)">delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click.stop="lAction = 'view'">Cancel</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      search: '',
      desig: [
        { text: 'Designation', value: 'emp_desig' },
        { text: 'Total Employees', value: 'tot_emp' }
      ],
      desigSm: [
        { text: 'Designation', value: 'emp_desig', class: 'pa-3' },
        { text: 'Total Employees', value: 'tot_emp', class: 'pa-2' },
        { text: 'Male', value: 'tot_male', class: 'pa-2' },
        { text: 'Female', value: 'tot_female', class: 'pa-2' }
      ],
      desigList: []
    }
  },
  mounted () {
    this.lAction = 'view'
    this.loadEmpDesign()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadEmpDesign () {
      // available Designation
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmpDesigByVendorId/', qry)
      .then(response => {
        this.desigList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    getEmptyDesign () {
      var emptyDesign = {
        emp_desig: '',
        vendor_id: config.VENDOR_ID
      }
      return emptyDesign
    },
    prepareCreate () {
      this.lEmpDesig = this.getEmptyDesign()
      this.lAction = 'create'
    },
    saveEmployeeDesign (action) {
      // validate and save Changes
      if (this.$refs.dForm.validate()) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/employeeDesign/' + action, this.lEmpDesig)
        .then(response => {
          // refresh the Employee Designation list
          this.lEmpDesig.emp_desig_id = response.data
          if (action === 'update') {
            var idx = this.desigList.findIndex(obj => obj.emp_desig_id === this.lEmpDesig.emp_desig_id)
            Object.assign(this.desigList[idx], this.lEmpDesig)
          } else {
            this.desigList.push(this.lEmpDesig)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareEditDesig (curDesign) {
      this.lEmpDesig = Object.assign({}, curDesign)
      this.lAction = 'update'
    },
    deleteDesign (curDesign) {
      if (!confirm('Sure, you want to delete the Designation with name "' + curDesign.emp_desig + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/employeeDesign/delete', curDesign)
       .then(response => {
        var idx = this.desigList.findIndex(obj => obj.emp_desig_id === this.lEmpDesig.emp_desig_id)
        this.desigList.splice(idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    }
  }
}
</script>
